class UserApi {
  static async getNonce(address) {
    const config = useRuntimeConfig()
    const url = `${config.app.externalApiBase}/users/nonce/${address}`
    const response = await http('get', url)
    return response?.data?.nonce
  }

  static async login(body) {
    const config = useRuntimeConfig()
    const url = `${config.app.externalApiBase}/users/login`
    const response = await http('post', url, { body })
    notify('success', response?.message || 'Successfull login')
    return response.data
  }

  static async getMyUser() {
    const config = useRuntimeConfig()
    const url = `${config.app.externalApiBase}/users/my-user`
    const response = await http('get', url, {}, true)
    return response.data
  }

  static async update(body) {
    const config = useRuntimeConfig()
    const url = `${config.app.externalApiBase}/users/my-user`
    const response = await http('post', url, { body }, true)
    notify('success', response?.message || 'Info has beeen added')
  }

  static async claim(body) {
    const config = useRuntimeConfig()
    const url = `${config.app.externalApiBase}/users/claim`
    const response = await http('post', url, { body }, true)
    notify('success', response?.message || 'Successfull claim')
  }

  static async verifyEmail(body) {
    const config = useRuntimeConfig()
    const url = `${config.app.externalApiBase}/users/verify-email`
    const response = await http('post', url, { body }, false)
    notify('success', response?.message || 'E-mail has been successfully verified!')
    return response
  }
}

export default UserApi
